export const RECAPTCHA_SCRIPT_ID = "zeffy-recaptcha-enterprise";

export enum RecaptchaAction {
  IsEmailRegistered = "IsEmailRegistered",
  CreateDonorFree = "CreateDonorFree",
  CreateDonor = "CreateDonor",
  ConfirmPaymentIntent = "ConfirmPaymentIntent",
  TicketingCreateCardPaymentIntent = "TicketingCreateCardPaymentIntent",
  TicketingCreatePadOrAchPaymentIntent = "TicketingCreatePadOrAchPaymentIntent",
  TicketingConfirmPaymentIntent = "TicketingConfirmPaymentIntent",
  DonationFormCreateCardPaymentIntent = "DonationFormCreateCardPaymentIntent",
  DonationFormCreatePadOrAchPaymentIntent = "DonationFormCreatePadOrAchPaymentIntent",
  DonationFormConfirmPaymentIntent = "DonationFormConfirmPaymentIntent",
  SignUp = "SignUp",
  SubmitCommand = "SubmitCommand",
  SubmitNewBids = "SubmitNewBids",
  PayPledge = "PayPledge",
  GoogleSSO = "GoogleSSO",
  UpdateDonationFormAmounts = "UpdateDonationFormAmounts",
  PostSubmitCommand = "PostSubmitCommand",
  SendSmsOtp = "SendSmsOtp",
  SendSmsOtpToSignin = "SendSmsOtpToSignin",
  SignIn = "SignIn",
  SignInAdmin = "SignInAdmin",
  SwitchOrgAdmin = "SwitchOrgAdmin",
  MagicLoginAdmin = "MagicLoginAdmin",
  ResendTransactionReceipt = "ResendTransactionReceipt",
  SendResetPasswordRequest = "SendResetPasswordRequest",
  TranslateText = "TranslateText",
  GenerateBannerWithAI = "GenerateBannerWithAI",
  GenerateAiEmail = "GenerateAiEmail",
  AnalyzeAiEmailPrompt = "AnalyzeAiEmailPrompt",
  StartEmailHtmlImport = "StartEmailHtmlImport",
  ApplyMagicCopyToEmailContent = "ApplyMagicCopyToEmailContent",
  SendEmailDelivery = "SendEmailDelivery",
  RefundTip = "RefundTip",
  SignUpToNewsletterForm = "SignUpToNewsletterForm",
  SendOrganizationPageContactMessage = "SendOrganizationPageContactMessage",
  HandleStytchGoogleAuth = "HandleStytchGoogleAuth",
  ActivateSmsMFA = "ActivateSmsMFA",
  VerifyTaxReceiptsToken = "VerifyTaxReceiptsToken",
  UpdatePhoneNumberAskToken = "UpdatePhoneNumberAskToken",
  UpdatePhoneNumber = "UpdatePhoneNumber",
  PublicUnsubscribeContact = "PublicUnsubscribeContact",
  SavePublicCommunicationPreferences = "SavePublicCommunicationPreferences",
  ConfirmCommunicationPreferences = "ConfirmCommunicationPreferences",
  UpdateCommandContact = "UpdateCommandContact",
  PausePayoutOrganizationRequest = "PausePayoutOrganizationRequest",
  PaypalCaptureOrder = "PaypalCaptureOrder",
  GetInvoice = "GetInvoice",
  SendVerifyEmailNotification = "SendVerifyEmailNotification",
  SubmitManualCommand = "SubmitManualCommand",
  SendMemberLoginLink = "SendMemberLoginLink",
  SendBidderLoginLink = "SendBidderLoginLink",
  SendBidderOtp = "SendBidderOtp",
  SendRecurringDonationLoginLink = "SendRecurringDonationLoginLink",
  CreateTeam = "CreateTeam",
  JoinTeam = "JoinTeam",
  CreateIndividualFundraising = "CreateIndividualFundraising",
  UpdateEventTicketGuestInfo = "UpdateEventTicketGuestInfo",
  CancelAttendance = "CancelAttendance",
}
